import React, { useState, useContext } from 'react';

import {
  useResponsiveParams,
  Button,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  InputGridGroup,
  SearchResultsModal,
  Text,
  Paper,
  NotificationList,
} from 'quanta-ui';
import { useFetchQuery } from 'quanta-flows';

import {
  faExclamationTriangle,
  faSearch,
  faUserCheck,
  faUserPlus,
  faUserTag,
  faBuilding,
  faExclamationCircle,
  faTimesCircle,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IndividualCustomerForm from './individualCustomerForm';
import OrganisationCustomerForm from './organisationCustomerForm';
import {
  GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  SEARCH_CUSTOMERS,
  GET_CUSTOMER_TYPE_DOMAIN,
  SAVE_QUOTE,
  GET_BUSINESS_TYPE,
  DEFAULT_ID_PROOF,
  SEARCH_CUSTOMER_BY_NUMBER ,
   CHECK_DUPLICATE_CUSTOMER,
  CHECK_IMD_CONFIG,
} from '../../queries';
import { CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL } from 'quanta-flows/modules/proposal/health';
// import { MOBILE_NUMBER_STARTING_WITH,
//   CHARACTER_LIMIT_LIST } from 'quanta-flows/modules/proposal/health';
import { MOBILE_NUMBER_STARTING_WITH ,CHARACTER_LIMIT_LIST} from 'quanta-flows/modules/quote/health';
// import { SEARCH_CUSTOMER_BY_NUMBER } from 'quanta-flows/modules/quote/health';
import { useQuery } from '@apollo/client';
import { Loading, Error } from 'quanta-flows/modules/layout';
// import Error from '../../../../../../lib/layout/error';
import { QuantaConfigContext } from 'quanta-flows';
import {
  resetProposerDetails,
  updateBuyHealthPolicy,
} from 'quanta-flows/modules/proposal/health/state';
import { useParams } from 'react-router-dom';
import { useMutationQuery } from 'quanta-flows';
import moment from 'moment';

export default function ProposerDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  //saveQuoteVariables,
  REACTIVE_VAR_QUERY,
  SAVE_QUOTE_QUERY,
  //resetProposerDetails,
  updateReactiveVar,
  preCustomerType,
  preGender,
  preDob,
  prePermPincode,
  prePermCityTownVillage,
  prePermState,
  prePermDistrict,
  planName,
  ...props
}) {
  const [isNewCustomerSelected, setIsNewCustomerSelected] =
    useState(null);
  const [isIndividualFormSelected, setIsIndividualFormSelected] =
    useState(null);

    const [isDuplicateCustomer ,setIsDuplicateCustomer]  = useState('');
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();
  // const { lob_code, product_code } = {'28',''};
  const lob_code = '28';
  const product_code = '2880';
  const params = useParams();
  const plan_name = planName ? planName : params?.plan_name;

  const [existingCustomerModal, showExistingCustomerModal] =
    useState(false);
  const [
    localExistingCustomerValues,
    setLocalExistingCustomerValues,
  ] = useState({
    customerType: 'Individual',
    searchType: 'Mobile Number',
  });
  const [existingCustomers, setExistingCustomers] = useState([]);
  const [loadingExistingCustomers,
    setLoadingExistingCustomers] =
    useState(false);
  const [loadingCustomerData, setLoadingCustomerData] =
    useState(false);
  const [onDataUpdate, setOnUpdate] = useState(null);
  const [isIdleDisplay, setIdleDisplay] = useState(true);
  const [errors, setErrors] = useState({
    existingCustomers: '',
    pincode: '',
  });
  const [alerts, setAlerts] = useState([]);
  const [customerSearchMetaMessage, setCustomerSearchMetaMessage] =
    useState({ type: '', message: '' });
  const [indvCustomerDomainArr, setIndvCustomerDomainArr] =
    useState(null);
  const { branding } = useContext(QuantaConfigContext);
  const [isConfigImd, setConfigImd] = useState(false);
  const {
    loading: loadingDefaultIdProof,
    error: errorDefaultIdProof,
    data: dataDefaultIdProof,
  } = useQuery(DEFAULT_ID_PROOF, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingCustomerIndividualDropdownDetails,
    error: errorCustomerIndividualDropdownDetails,
    data: dataCustomerIndividualDropdownDetails,
  } = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL);
  const {
    loading: loadingMobileNumberLength,
    error: errorMobileNumberLength,
    data: dataMobileNumberLength,
  } = useQuery(MOBILE_NUMBER_STARTING_WITH, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingCharacterLimitList,
    error: errorCharacterLimitList,
    data: dataCharacterLimitList,
  } = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
  });
  const { loading, error, data } = useQuery(
    GET_BUY_HEALTH_POLICY_VAR_DETAILS,
    {
      fetchPolicy: 'cache-first',
      onCompleted: async (data) => {
        const { buyHealthPolicy } = data;
        try{
          let ImdConfigQuery = fetchQuery({
            query: CHECK_IMD_CONFIG,
            fetchPolicy: 'cache-first',
            variables: {
              intermediaryCode: buyHealthPolicy?.intermediaryDetails?.code,
            },
          });
          setLoadingCustomerData(true);
          let { data: dataImdCongig } = await ImdConfigQuery;
          setLoadingCustomerData(false);
          setConfigImd(dataImdCongig?.checkConfigImd?.isConfiguredIMD);
        }catch(error){
          setAlerts([
            {
              header: 'IMD Config',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setLoadingCustomerData(false);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        if (buyHealthPolicy.customerFetchRequiredOnLoad) {
          if (buyHealthPolicy.proposerDetails.id) {
            try {
              let queryOutput = fetchQuery({
                query: SEARCH_CUSTOMER_BY_NUMBER,
                fetchPolicy: 'network-only',
                variables: {
                  input: {
                    customer_type:
                      buyHealthPolicy.proposerDetails.customerType,
                      customer_number:
                        buyHealthPolicy.proposerDetails.id,
                    },
                },
              });
              setLoadingCustomerData(true);
              let { data } = await queryOutput;
              setLoadingCustomerData(false);
              setIsNewCustomerSelected(false);
              updateBuyHealthPolicy(reinitialiseForm(data));
            } catch (error) {
              setErrors({
                ...errors,
                existingCustomers: error.message,
              });
              setAlerts([
                {
                  header: 'Customer details cannot be fetched',
                  id: Date.now(),
                  content: (
                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                      <span>{error.message}</span>
                    </div>
                  ),
                  type: 'error',
                  timeout: null,
                  disableClose: false,
                },
              ]);
              setLoadingCustomerData(false);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }
        } else if (!buyHealthPolicy?.proposerDetails?.idProofType) {
          try {
            let defaultIdProofQuery = fetchQuery({
              query: DEFAULT_ID_PROOF,
            });
            let customerIndvDropDown = fetchQuery({
              query: CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
              fetchPolicy: 'cache-first',
            });
            setLoadingCustomerData(true);
            let { data } = await defaultIdProofQuery;
          //  let { data } = await defaultIdProofQuery;
            let { data: dataCustomerDropdowndetails } =
              await customerIndvDropDown;
            setLoadingCustomerData(false); 
            setIndvCustomerDomainArr(dataCustomerDropdowndetails);
            setLoadingCustomerData(false);
            updateBuyHealthPolicy({
              proposerDetails: {
                idProofType: data?.defaultIdProof?.code,
                gender: dataCustomerDropdowndetails?.genderList[0]?.code
                ? `${dataCustomerDropdowndetails?.genderList[0]?.code}`
                : '',
              title: dataCustomerDropdowndetails?.salutationList[0]
                ?.code
                ? `${dataCustomerDropdowndetails?.salutationList[0]?.code}`
                : '',
              maritalStatus: dataCustomerDropdowndetails
                ?.maritalStatusList[0]?.code
                ? `${dataCustomerDropdowndetails?.maritalStatusList[0]?.code}`
                : '',
              nationality: dataCustomerDropdowndetails
                ?.nationalityList[0]?.code
                ? `${dataCustomerDropdowndetails?.nationalityList[0]?.code}`
                : '',
              idProofNumber : data?.defaultIdProof?.code?.toString() === '3' 
                ? '99999'
                : '',
              },
            });
          } catch (error) {
            setErrors({
              ...errors,
              existingCustomers: error.message,
            });
            setAlerts([
              {
                header: 'Customer details cannot be fetched',
                id: Date.now(),
                content: (
                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                    <span>{error.message}</span>
                  </div>
                ),
                type: 'error',
                timeout: null,
                disableClose: false,
              },
            ]);
            setLoadingCustomerData(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
      },
    },
  );
  const {
    loading: loading_cust_type_domain_arr,
    error: error_cust_type_domain_arr,
    data: data_cust_type_domain_arr,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingBusinessType,
    error: errorBusinessType,
    data: businessTypeData,
  } = useQuery(GET_BUSINESS_TYPE, { fetchPolicy: 'cache-first' });

  let repeat = useResponsiveParams({ for_mobile: 1, for_desktop: 4 });

  const inputColSpans = useResponsiveParams({
    for_mobile: { searchString: 5, searchType: 3, button: 2 },
    for_desktop: { searchString: 3, searchType: 1, button: 1 },
  });
  const checkDuplicateCustVariables = (values) => {
    return {
      id: values?.id,
      customerType: values?.customerType,
      gender: values?.gender,
      firstName: values?.firstName,
      middleName: values?.middleName,
      lastName: values?.lastName,
      fullName: values?.fullName,
      proposerDOB: values?.proposerDOB,
      panNumber: values?.panNumber,
      orgName: values?.orgName,
      orgType: values?.orgType,
      permAddressLine1: values?.permAddressLine1,
      permAddressLine2: values?.permAddressLine2,
      permAddressLine3: values?.permAddressLine3,
      permLandmark: values?.permLandmark,
      permPincode: values?.permPincode,
      permCityTownVillage: values?.permCityTownVillage,
      permDistrict: values?.permDistrict,
      permState: values?.permState,
      permCommAddressYN: values?.permCommAddressYN,
      commAddressLine1: values?.commAddressLine1,
      commAddressLine2: values?.commAddressLine2,
      commAddressLine3: values?.commAddressLine3,
      commLandmark: values?.commLandmark,
      commPincode: values?.commPincode,
      commCityTownVillage: values?.commCityTownVillage,
      commDistrict: values?.commDistrict,
      commState: values?.commState,
      phoneNo: values?.phoneNo,
      mobileNo: values?.mobileNo,
      emailID: values?.emailID,
    };
  }
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };
  const AdhaarNumberMasking = (aadhaarNo) =>{
    let Str='';
    for(let i =0;i <aadhaarNo?.length ; i++){
      if(i<8)
        Str+="X";
      else{
        Str+=aadhaarNo[i];
      }
    }
    return Str;
  };
  const getSearchTextPlaceholder = (searchType, customerType) => {
    switch (searchType) {
      case 'Customer Number':
        return 'Enter customer ID to search...';
      // case 'Customer Name':
      //   return customerType === 'Individual' || !customerType
      //     ? 'Enter customer name to search...'
      //     : 'Enter organisation name to search...';
      case 'Mobile Number':
        return "Enter customer's mobile number to search...";
      case 'PAN No':
        return searchType === 'Individual'
          ? 'Enter PAN Number to search...'
          : 'Enter PAN Number to search...';
      case 'CKYC Id':
        return "Enter customer's CKYC ID to search...";
      default:
        return customerType === 'Individual' || !customerType
          ? "Enter customer's mobile number to search..."
          : 'Enter organisation name to search...';
    }
  };

  const getSearchObject = (
    customerType,
    searchType,
    searchString,
  ) => {
    return {
      customer_type: customerType,
      customer_number:
        searchType === 'Customer Number' ? searchString : undefined,
      // customer_name:
      //   searchType === 'Customer Name' ? searchString : undefined,
      mobile:
        searchType === 'Mobile Number' ? searchString : undefined,
      ckyc_id:
        searchType === 'CKYC Id'
          ? searchString
          : undefined,
      pan_no:
        searchType === 'PAN No'
          ? searchString
          : undefined,
    };
  };

  const reinitialiseForm = (data) => {
    const { customer } = data;
    return {
      customerFetchRequiredOnLoad: false,
      proposerDetailsMeta: {
        crn: reformData(customer?.cust_ref_number, ''),
        isNewCustomer: false,
        ifscCode: reformData(customer?.bank_detail?.ifsc_code, ''),
        bankName: reformData(customer?.bank_detail?.name, ''),
        branchName: reformData(customer?.branch_name, ''),
        bankAcno: reformData(customer?.bank_detail?.acc_number, ''),
        accountHolderName: reformData(
          customer?.bank_detail?.acc_holder,
          '',
        ),
        micrCode: reformData(customer?.bank_detail?.micr_code, ''),
      },
      proposerDetails: {
        id: reformData(customer?.cust_number, ''),
        customerType: reformData(customer?.cust_type?.code, ''),
        title: reformData(customer?.indv_detail?.title?.code, ''),
        gender: reformData(customer?.indv_detail?.gender?.code, ''),
        firstName: reformData(customer?.indv_detail?.first_name, ''),
        middleName: reformData(
          customer?.indv_detail?.middle_name,
          '',
        ),
        employeeNumber: reformData(
          customer?.indv_detail?.employeeNumber,
          '',
        ),
        lastName: reformData(customer?.indv_detail?.surname, ''),
        fullName: reformData(customer?.indv_detail?.full_name, ''),
        maritalStatus: reformData(
          customer?.indv_detail?.marital_status?.code,
          '',
        ),
        nationality: reformData(
          customer?.indv_detail?.nationality?.code,
          '',
        ),
        occupation: reformData(
          customer?.indv_detail?.occupation?.code,
          '',
        ),
        proposerDOB: reformData(
          customer?.indv_detail?.date_of_birth,
          '',
        ),
        panNumber: reformData(
          customer?.indv_detail?.pan_card_number,
          '',
        ),
        idProofType: reformData(
          customer?.indv_detail?.id_proof_type?.code,
          '',
        ),
        idProofNumber: reformData(
          customer?.indv_detail?.id_proof_number ? 
           customer?.indv_detail?.id_proof_number : '99999', 
          '',
        ),
        idProofNumberMaskedValue : reformData(
          customer?.indv_detail?.id_proof_type?.code?.toString() === '10' ?
          customer?.indv_detail?.id_proof_number 
          ? AdhaarNumberMasking(customer?.indv_detail?.id_proof_number) 
          :'' : '',
          '',
        ),
        permAddressLine1: reformData(
          customer?.permanent_address?.address_line1,
          '',
        ),
        permAddressLine2: reformData(
          customer?.permanent_address?.address_line2,
          '',
        ),
        permAddressLine3: reformData(
          customer?.permanent_address?.address_line3,
          '',
        ),
        permLandmark: reformData(
          customer?.permanent_address?.land_mark,
          '',
        ),
        permPincode: reformData(
          customer?.permanent_address?.pin_code,
          '',
        ),
        permCityTownVillage: reformData(
          customer?.permanent_address?.city,
          '',
        ),
        permDistrict: reformData(
          customer?.permanent_address?.district,
          '',
        ),
        permState: reformData(customer?.permanent_address?.state, ''),
        permCommAddressYN: customer?.comm_equal_perm,
        commAddressLine1: reformData(
          customer?.communication_address?.address_line1,
          '',
        ),
        commAddressLine2: reformData(
          customer?.communication_address?.address_line2,
          '',
        ),
        commAddressLine3: reformData(
          customer?.communication_address?.address_line3,
          '',
        ),
        commLandmark: reformData(
          customer?.communication_address?.land_mark,
          '',
        ),
        commPincode: reformData(
          customer?.communication_address?.pin_code,
          '',
        ),
        commCityTownVillage: reformData(
          customer?.communication_address?.city,
          '',
        ),
        commDistrict: reformData(
          customer?.communication_address?.district,
          '',
        ),
        commState: reformData(
          customer?.communication_address?.state,
          '',
        ),
        mobileNo: reformData(customer?.contact?.mobile, ''),
        emailID: reformData(customer?.contact?.email),
        orgName: reformData(customer?.org_detail?.org_name, ''),
        orgType: reformData(customer?.org_detail?.org_type?.code, ''),
        contactName: reformData(
          customer?.org_detail?.contact_name,
          '',
        ),
        regNumber: reformData(customer?.org_detail?.reg_number, ''),
        tanNumber: reformData(customer?.org_detail?.tan_number, ''),
        gstNumber: reformData(
          getDomainData(
            data_cust_type_domain_arr?.customerTypeList,
            customer?.cust_type?.code,
            'code',
            'value',
          )?.toLowerCase() === 'individual'
            ? customer?.indv_detail?.gst_number
            : customer?.org_detail?.gst_number,
          '',
        ),
        /*SADivya - CR P2_233: KYC*/
        motherMaidenName : reformData(
          customer?.indv_detail?.mother_maiden_name,
          '',
        ),
        eiaRequired : reformData(
          customer?.indv_detail?.eia_required,
          '',
        ),
        eiaNumber:reformData(
          customer?.indv_detail?.eia_number,
          '',
        ),
        ckycIdNumber:reformData(
          getDomainData(
            data_cust_type_domain_arr?.customerTypeList,
            customer?.cust_type?.code,
            'code',
            'value',
          )?.toLowerCase() === 'individual'
            ? customer?.indv_detail?.ckyc_id_number
            : customer?.org_detail?.ckyc_id_number,
          '',
        ),
        certificateOfInCorporation:reformData(customer?.org_detail?.certificate_of_incorporation, ''),
        udyogAadhaarNumber:reformData(customer?.org_detail?.udyog_aadhaar_number, ''),
        /*EADivya - CR P2_233: KYC*/
        phoneNo: reformData(customer?.contact?.telephone, ''),
        faxNo: reformData(customer?.contact?.fax_number, ''),
        altPhoneNo: reformData(customer?.contact?.alt_telephone, ''),
        altMobileNo: reformData(customer?.contact?.alt_mobile, ''),
        /**SADivya - CR498 */
        dateOfIncorporation: reformData(customer?.org_detail?.date_of_incorporation, ''),
        form60:  customer?.indv_detail?.form_60,
        isPanAvailable:reformData(
          (customer?.indv_detail?.pan_card_number
            || customer?.org_detail?.pan_card_number) 
            ? 'Yes'
            : 'No',
          '',
        ), 
        /**EADivya - CR498 */
      },
    };
  };

  const icon_idle = (
    <img
      src={branding.illustration.no_data}
      alt="no data"
      className="lg:w-80 lg:h-80 w-64 h-64 opacity-50"
    />
  );

  const {
    loading: buyHealthPolicyLoading,
    error: errorBuyHealthPolicy,
    data: dataBuyHealthPolicy,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS);
  if (dataBuyHealthPolicy) {
    var prembuyHealthPolicy = dataBuyHealthPolicy?.buyHealthPolicy;
    var prempquoteData = prembuyHealthPolicy?.quoteData;
    var premplanData = prembuyHealthPolicy?.planData;
    var plans = premplanData?.plans;
  }
  let Prem_data;
  Prem_data = plans?.find((p) => p.name === plan_name)?.premium
    ?.totalPremium
   const validate = (values) => {
    let errors = {};
    errors.proposerDetails = {};
    errors.proposerDetailsMeta = {};
    if (
      (isNewCustomerSelected &&
        (isIndividualFormSelected ||
          values.proposerDetails.customerType ===
          getDomainData(
            data_cust_type_domain_arr?.customerTypeList,
            'Individual',
            'value',
            'code',
          ))) ||
      (!isNewCustomerSelected &&
        buyHealthPolicy?.proposerDetails?.customerType ===
        getDomainData(
          data_cust_type_domain_arr?.customerTypeList,
          'Individual',
          'value',
          'code',
        ))
    ) {
      if (!values.proposerDetails.title) {
        errors.proposerDetails.title = '* Required';
      }
      function titlelist(salutationList) {
        var arr = [];
        for (let i = 0; i <= 28; i++) {
          arr.push(salutationList[i].value);
        }
        return arr;
      }
      const abc = titlelist(indvCustomerDomainArr.salutationList);
      function titleCase(str) {
        str = str.toLowerCase().split(' ');
        for (var i = 0; i < str.length; i++) {
          str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
        }
        return str.join(' ');
      }
      if (
        indvCustomerDomainArr &&
        (
	values.proposerDetails.title?.toLowerCase() !==
          getDomainData(
            indvCustomerDomainArr.salutationList,
            values.proposerDetails.title,
            'code',
            'code',
          )?.toLowerCase()
          &&
          (!abc.includes(titleCase(values.proposerDetails.title)))
        )) {
        // console.log("487")
        errors.proposerDetails.title = '* Enter valid title';
      }
      else if (
        indvCustomerDomainArr &&
        getDomainData(
          indvCustomerDomainArr.salutationList,
          values.proposerDetails.title,
          'code',
          'gender',
        )?.toLowerCase() && values.proposerDetails.gender?.toLowerCase() !==
        getDomainData(
          indvCustomerDomainArr.salutationList,
          values.proposerDetails.title,
          'code',
          'gender',
        )?.toLowerCase() && (getDomainData(
          indvCustomerDomainArr.genderList,
          values.proposerDetails.gender,
          'code',
          'value',
        )?.toLowerCase() === 'male' || getDomainData(
          indvCustomerDomainArr.genderList,
          values.proposerDetails.gender,
          'code',
          'value',
        )?.toLowerCase() === 'female')
      ) {
        errors.proposerDetails.title = '* Title mismatch with gender';
      }
      if (!values.proposerDetails.gender) {
        errors.proposerDetails.gender = '* Required';
      }
      if (!values.proposerDetails.proposerDOB) {
        errors.proposerDetails.proposerDOB = '* Required';
      }
      if (values.proposerDetails.proposerDOB) {
        if (
          moment(
            values.proposerDetails.proposerDOB,
            'DD/MM/YYYY',
          ).isAfter()
        ) {
          errors.proposerDetails.proposerDOB =
            '* Date of Birth cannot be a future date';
        }
      }
      if (!values.proposerDetails.firstName) {
        errors.proposerDetails.firstName = '* Required';
      }
      if (
        values.proposerDetails.firstName &&
        values.proposerDetails.firstName.match(/\d/)
      ) {
        errors.proposerDetails.firstName =
          '* First name cannot be alphanumeric';
      }
      if (
        values.proposerDetails.firstName &&
        !values.proposerDetails.firstName.match(/\d/) &&
        !values.proposerDetails.firstName.match(/^[a-zA-Z\s]+$/)
      ) {
        errors.proposerDetails.firstName =
          '* First name cannot contain special characters';
      }
      if (
        values.proposerDetails.middleName &&
        values.proposerDetails.middleName.match(/\d/)
      ) {
        errors.proposerDetails.middleName =
          '* Middle name cannot not be alphanumeric';
      }
      if (
        values.proposerDetails.middleName &&
        !values.proposerDetails.middleName.match(/\d/) &&
        !values.proposerDetails.middleName.match(/^[a-zA-Z\s]+$/)
      ) {
        errors.proposerDetails.middleName =
          '* Middle name cannot contain special chacracters';
      }
      if (!values.proposerDetails.lastName) {
        errors.proposerDetails.lastName = '* Required';
      }
      if (
        values.proposerDetails.lastName &&
        values.proposerDetails.lastName.match(/\d/)
      ) {
        errors.proposerDetails.lastName =
          '* Last name cannot be alphanumeric';
      }
      if (
        values.proposerDetails.lastName &&
        !values.proposerDetails.lastName.match(/\d/) &&
        !values.proposerDetails.lastName.match(/^[a-zA-Z.\s]+$/)
      ) {
        errors.proposerDetails.lastName =
          '* Last name should not contain special characters';
      }
      if (!values.proposerDetails.maritalStatus) {
        errors.proposerDetails.maritalStatus = '* Required';
      }
      if (!values.proposerDetails.nationality) {
        errors.proposerDetails.nationality = '* Required';
      }
      if (!values.proposerDetails.occupation) {
        errors.proposerDetails.occupation = '* Required';
      }
      // if ((values.proposerDetails?.occupation =="7") && (!values.proposerDetails?.otherOccupation )) {
      //   errors.proposerDetails.otherOccupation = '* Required';
      // }
      //PAN card or id proof mandatory
      /**SUDivya : CR498 - PAN as Mandatory */
      if (!values.proposerDetails?.isPanAvailable) {
        errors.proposerDetails.isPanAvailable = '* Required';
      }
      if (values.proposerDetails?.isPanAvailable?.toString()?.toLowerCase() === 'yes'
        || values.proposerDetails?.isPanAvailable?.toString()?.toLowerCase() === 'true') {
        if (!values.proposerDetails.panNumber
          && !values.proposerDetails.idProofType
          && !values.proposerDetails.idProofNumber) {
          errors.proposerDetails.panNumber = '* Either PAN Card Number OR ID Proof Number is Mandatory';
        }
        if (!values.proposerDetails.panNumber) {
          errors.proposerDetails.panNumber = '*Required';
          if (Prem_data >= 50000) {
            errors.proposerDetails.panNumber = '* PAN Card Number is Mandatory if Premium amount is greater than 50000';
          }
        }
        //P2_632
        else if (values.proposerDetails.panNumber) {
          if (values?.proposerDetails?.panNumber?.substring(3, 4)?.toString()?.toLowerCase() !== 'p' &&
            values?.proposerDetails?.customerType?.toString()?.toLowerCase() === 'individual') {
            errors.proposerDetails.panNumber = '* 4th Letter should be P';
          }
        }
        //P2_632
      }
      if(values.proposerDetails?.isPanAvailable?.toString()?.toLowerCase() === 'no'
       || values.proposerDetails?.isPanAvailable?.toString()?.toLowerCase() === 'false'){
        if (!values.proposerDetails.form60) {
          errors.proposerDetails.form60 = '* Required';
        }
      }
      /**EADivya : CR498 - PAN as Mandatory */
      if (
        buyHealthPolicy?.quoteData?.isExistingEmployee?.toLowerCase() ===
        'yes' &&
        !values.proposerDetails.employeeNumber
      ) {
        errors.proposerDetails.employeeNumber = '* Required';
      }
      if (values.proposerDetails.gstNumber) {
        var reggst =
        /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([1-9A-Z]){1}([zZ]){1}([0-9A-Z]){1}?$/;
        if (values.proposerDetails.gstNumber.length !== 15) {
          errors.proposerDetails.gstNumber =
            '* GST Number must be of 15 digits';
        } else if (!reggst.test(values.proposerDetails.gstNumber)) {
          errors.proposerDetails.gstNumber =
            '* Please Enter valid GST Number';
        }
      }
      if (values.proposerDetails.panNumber) {
        if (values.proposerDetails.panNumber.length !== 10) {
          errors.proposerDetails.panNumber =
            '* PAN number must be of 10 digits';
        } else if (
          !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(
            values.proposerDetails.panNumber,
          )
        ) {
          errors.proposerDetails.panNumber =
            '* Please enter valid PAN number';
        }
      }
      if (values?.proposerDetails?.eiaNumber && 
        !(values?.proposerDetails?.eiaNumber?.toString()?.toLowerCase()?.startsWith('1')
        || values?.proposerDetails?.eiaNumber?.toString()?.toLowerCase()?.startsWith('2')
        ||values?.proposerDetails?.eiaNumber?.toString()?.toLowerCase()?.startsWith('4')
        ||values?.proposerDetails?.eiaNumber?.toString()?.toLowerCase()?.startsWith('5') )) {
         errors.proposerDetails.eiaNumber = '* number should only start with 1, 2, 4 or 5';
     }
      // if (!values.proposerDetails.idProofType) {
      //   errors.proposerDetails.idProofType = '* Required';
      // }
      // if (!values.proposerDetails.idProofNumber) {
      //   errors.proposerDetails.idProofNumber = '* Required';
      // }
    /*SU Divya : CR P2_233 KYC :Remove Validtion For ID Proof*/
      // if (!values.proposerDetails.idProofType && !values.proposerDetails.panNumber && !values.proposerDetails.idProofNumber) {

      //   errors.proposerDetails.idProofType = '* Either PAN Card Number OR ID Proof Number is Mandatory';

      // }

      // if (!values.proposerDetails.idProofNumber && !values.proposerDetails.panNumber && !values.proposerDetails.idProofNumber) {

      //   errors.proposerDetails.idProofNumber = '* Either PAN Card Number OR ID Proof Number is Mandatory';

      // }
      // if (values.proposerDetails.idProofType  && values.proposerDetails.panNumber && !values.proposerDetails.idProofNumber) {
      //   errors.proposerDetails.idProofNumber = '* As ID Proof Type is selected, please enter ID Proof Number';
      // }
      // if (values.proposerDetails.idProofType  && !values.proposerDetails.idProofNumber) {
      //   errors.proposerDetails.idProofNumber = '* As ID Proof Type is selected, please enter ID Proof Number';
      // }
      // if (!values.proposerDetails.idProofType  && values.proposerDetails.idProofNumber) {
      //   errors.proposerDetails.idProofType = '* As ID Proof Number is entered, please enter ID Proof Type';
      // }
      // if (
      //   indvCustomerDomainArr &&
      //   values.proposerDetails.idProofNumber &&
      //   values.proposerDetails.idProofType ===
      //   getDomainData(
      //     indvCustomerDomainArr.idProofTypeList,
      //     'Passport',
      //     'value',
      //     'code',
      //   )
      // ) {
      //   let regPassport = /^([a-zA-Z]){1}([0-9]){7}?$/;
      //   if (values.proposerDetails.idProofNumber.length !== 8) {
      //     errors.idProofNumber =
      //       '* Passport number must be of 8 digits';
      //   }
      //   if (!regPassport.test(values.proposerDetails.idProofNumber) && !values.proposerDetails.panNumber) {
      //     errors.proposerDetails.idProofNumber =
      //       '* Enter valid passport number';
      //   }
      // }
      // if (
      //   indvCustomerDomainArr &&
      //   values.proposerDetails.idProofNumber &&
      //   values.proposerDetails.idProofType ===
      //   getDomainData(
      //     indvCustomerDomainArr.idProofTypeList,
      //     'Driving License',
      //     'value',
      //     'code',
      //   )
      // ) {
      //   // let regDrvLic = /^([a-zA-Z]){2}([0-9]){14}?$/;
      //   let regDrvLic = /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}?$/;
      //   if (values.proposerDetails.idProofNumber.length !== 16) {
      //     errors.proposerDetails.idProofNumber =
      //       '* Driving license number must be of 16 digits';
      //   }
      //   if (!regDrvLic.test(values.proposerDetails.idProofNumber) && !values.proposerDetails.panNumber) {
      //     errors.proposerDetails.idProofNumber =
      //       '* Enter valid driving license number';
      //   }
      // }
      // if (
      //   indvCustomerDomainArr &&
      //   values.proposerDetails.idProofNumber &&
      //   values.proposerDetails.idProofType ===
      //   getDomainData(
      //     indvCustomerDomainArr.idProofTypeList,
      //     'Voter I-Card',
      //     'value',
      //     'code',
      //   )
      // ) {
      //   let x = values.proposerDetails.idProofNumber;
      //   if (x !== '99999') {
      //     let regVoter = /^([a-zA-Z]){3}([0-9]){7}?$/;
      //     if (values.proposerDetails.idProofNumber.length !== 10) {
      //       errors.proposerDetails.idProofNumber =
      //         '* Voter I-Card number must be of 10 digits';
      //     }
      //     if (!regVoter.test(values.proposerDetails.idProofNumber) && !values.proposerDetails.panNumber) {
      //       errors.proposerDetails.idProofNumber =
      //         '* Enter valid Voter I-Card number';
      //     }
      //   }
      // }
  /*EU Divya : CR P2_233 KYC :Remove Validtion For ID Proof*/
      if (isConfigImd && (sessionStorage?.getItem('roleName')?.toString()?.toLowerCase() !== 'bancsassurance' &&
        sessionStorage?.getItem('roleName')?.toString()?.toLowerCase() !== 'corporate agent')) {
        if (!values.proposerDetailsMeta.ciuType) {
          errors.proposerDetailsMeta.ciuType = '* Required';
          errors.proposerDetailsMeta.isConfigIMD = `Please provide Other Bank CRN details`;
        }
        if (values.proposerDetailsMeta.ciuType
          && values.proposerDetailsMeta.ciuType !== 'Other Bank CRN'
        ) {
          errors.proposerDetailsMeta.ciuType = '* select Other Bank CRN';
          errors.proposerDetailsMeta.isConfigIMD = `Please provide Other Bank CRN details`;
        }
        if (!values.proposerDetailsMeta.crn) {
          errors.proposerDetailsMeta.crn = '* Required';
          errors.proposerDetailsMeta.isConfigIMD = `Please provide Other Bank CRN details`;
        }
        if (values.proposerDetailsMeta.ciuType === 'Other Bank CRN'
          && !values.proposerDetailsMeta.crn) {
          errors.proposerDetailsMeta.crn = '* Required';
          errors.proposerDetailsMeta.isConfigIMD = `Please provide Other Bank CRN details`;
        }
      }
    } else if (
      (isNewCustomerSelected &&
        (isIndividualFormSelected === false ||
          values.proposerDetails.customerType ===
          getDomainData(
            data_cust_type_domain_arr?.customerTypeList,
            'Organisation',
            'value',
            'code',
          ))) ||
      (!isNewCustomerSelected &&
        buyHealthPolicy?.proposerDetails?.customerType ===
        getDomainData(
          data_cust_type_domain_arr?.customerTypeList,
          'Organisation',
          'value',
          'code',
        ))
    ) {
      if (!values.proposerDetails.orgName) {
        errors.proposerDetails.orgName = '* Required';
      }
      //Organisation Type CHanges
      if (!values?.proposerDetails?.orgType) {
        errors.proposerDetails.orgType = '* Required';
      }
      //Organisation Type CHanges
    /*SUDivya - CR P2_233 :KYC :Remove Validation*/
      // if (!values.proposerDetails.regNumber) {
      //   errors.proposerDetails.regNumber = '* Required';
    
      // }
      /*EUDivya - CR P2_233 :KYC :Remove Validation*/
     
    /*SADivya - CR P2_233 :KYC :Added Validation*/
      // if (!values.proposerDetails?.certificateOfInCorporation) {
      //       errors.proposerDetails.certificateOfInCorporation = '* Required';
      //     }
    /*EADivya - CR P2_233 :KYC :Added Validation*/
     // if (!values.proposerDetails.contactName) {
     //   errors.proposerDetails.contactName = '* Required';
     //}
      if (
        values.proposerDetails.contactName &&
        values.proposerDetails.contactName.match(/\d/)
      ) {
        errors.proposerDetails.contactName =
          '* Name cannot be alphanumeric';
      }
      if (
        values.proposerDetails.contactName &&
        !values.proposerDetails.contactName.match(/\d/) &&
        !values.proposerDetails.contactName.match(/^[a-zA-Z\s]+$/)
      ) {
        errors.proposerDetails.contactName =
          '* Name cannot contain special characters';
      }
      if (values.proposerDetails.faxNo > 1) {
        if (
          values.proposerDetails.faxNo.toString().length !== 10 ||
          !values.proposerDetails.faxNo.toString().match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.faxNo =
            '* faxNo number must be of 10 digits';
        }
      }
      if (values.proposerDetails.altPhoneNo > 1) {
        if (
          values.proposerDetails.altPhoneNo.toString().length !==
          10 ||
          !values.proposerDetails.altPhoneNo
            .toString()
            .match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.altPhoneNo =
            '* Telephone number must be of 10 digits';
        }
      }
      if (values.proposerDetails.phoneNo > 1) {
        if (
          values.proposerDetails.phoneNo.toString().length !== 10 ||
          !values.proposerDetails.phoneNo.toString().match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.phoneNo =
            '* Telephone number must be of 10 digits';
        }
      }
      if (values.proposerDetails.altMobileNo > 1) {
        if (
          values.proposerDetails.altMobileNo.toString().length !==
          10 ||
          !values.proposerDetails.altMobileNo
            .toString()
            .match(/^[0-9]+$/)
        ) {
          errors.proposerDetails.altMobileNo =
            '* Mobile number must be of 10 digits';
        }
      }
      if (!values.proposerDetails.tanNumber) {
        errors.proposerDetails.tanNumber != '* Required';
      }
      if (values.proposerDetails.tanNumber) {
        var regtan = /^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/;

        if (values.proposerDetails.tanNumber.length !== 10) {
          errors.proposerDetails.tanNumber =
            '* TAN Number must be of 10 digits';
        }
        else if (!regtan.test(values.proposerDetails.tanNumber)) {
          errors.proposerDetails.tanNumber =
            '* Please Enter valid TAN Number';
        }
      }
      if (!values.proposerDetails.gstNumber) {
        errors.proposerDetails.gstNumber != '* Required';
      }
      if (values.proposerDetails.gstNumber) {
        var reggst =
        /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([1-9A-Z]){1}([zZ]){1}([0-9A-Z]){1}?$/;
        if (values.proposerDetails.gstNumber.length !== 15) {
          errors.proposerDetails.gstNumber =
            '* GST Number must be of 15 digits';
        } else if (!reggst.test(values.proposerDetails.gstNumber)) {
          errors.proposerDetails.gstNumber =
            '* Please Enter valid GST Number';
        }
      }
      /**SADivya :  CR P2_498 - PAN Mandatory */
      if (!values.proposerDetails.panNumber) {
        errors.proposerDetails.panNumber = '* Required';
      }
      if (values.proposerDetails.panNumber) {
        if (values.proposerDetails.panNumber.length !== 10) {
          errors.proposerDetails.panNumber =
            '* PAN number must be of 10 digits';
        } else if (
          !/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(
            values.proposerDetails.panNumber,
          )
        ) {
          errors.proposerDetails.panNumber =
            '* Please enter valid PAN number';
        }
      }
      /**SADivya : CR P2_498 - PAN Mandatory */
    }

    if (!values.proposerDetails.permAddressLine1) {
      errors.proposerDetails.permAddressLine1 = '* Required';
    }
    // if (!values.proposerDetails.permAddressLine2) {
    //   errors.proposerDetails.permAddressLine2 != '* Required';
    // }
    // if (values.proposerDetails.permAddressLine1&&
    //   !values.proposerDetails.permAddressLine1.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/))
    //    {
    //   errors.proposerDetails.permAddressLine1 = '* Address Cannot contain any Special Characters';
    //    }
    // if (values.proposerDetails.permAddressLine2&&
    //    !values.proposerDetails.permAddressLine2.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/)){
    //    errors.proposerDetails.permAddressLine2= '* Address Cannot contain any Special Characters';
    //    }
    //    if (values.proposerDetails.permAddressLine3&&
    //     !values.proposerDetails.permAddressLine3.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/)) {
    //     errors.proposerDetails.permAddressLine3= '* Address Cannot contain any Special Characters';
    //     }
    // if (values.proposerDetails.permLandmark&&
    //   !values.proposerDetails.permLandmark.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/)) {
    //   errors.proposerDetails.permLandmark= '* Landmark Cannot contain any Special Characters';
    // }
    if (!values.proposerDetails.permPincode) {
      errors.proposerDetails.permPincode = '* Required';
    }
    if (
      values.proposerDetails.permPincode &&
      (values.proposerDetails.permPincode.length !== 6 ||
        !values.proposerDetails.permPincode.match(/^[0-9]+$/))
    ) {
      errors.proposerDetails.permPincode =
        '* Pincode must be of 6 digits';
    }
    if (
      values.proposerDetails.permPincode &&
      values.proposerDetails.permPincode.length === 6 &&
      (!values.proposerDetails.permCityTownVillage ||
        !values.proposerDetails.permState ||
        !values.proposerDetails.permDistrict)
    ) {
      errors.proposerDetails.permPincode =
        '*Click the search icon to fetch city, district and state';
    }
    if (!values.proposerDetails.commPermSame) {
      if (!values.proposerDetails.commAddressLine1) {
        errors.proposerDetails.commAddressLine1 = '* Required';
      }
      // if (!values.proposerDetails.commAddressLine2) {
      //   errors.proposerDetails.commAddressLine2 != '* Required';
      // }
      // if (values.proposerDetails.commAddressLine1&&
      //   !values.proposerDetails.commAddressLine1.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/)) {
      //   errors.proposerDetails.commAddressLine1 = '* Address Cannot contain any Special Characters';
      //    }
      // if (values.proposerDetails.commAddressLine2&&
      //    !values.proposerDetails.commAddressLine2.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/)) {
      //    errors.proposerDetails.commAddressLine2= '* Address Cannot contain any Special Characters';
      //    }
      //    if (values.proposerDetails.commAddressLine3&&
      //     !values.proposerDetails.commAddressLine3.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/)) {
      //       console.log("values-------------------->",values.proposerDetails)
      //     errors.proposerDetails.commAddressLine3= '* Address Cannot contain any Special Characters';
      //     }
      // if (values.proposerDetails.commLandmark&&
      //   !values.proposerDetails.commLandmark.match(/^[a-zA-Z0-9\.\'()\-,\/ \&\:]*$/)) {
      //   errors.proposerDetails.commLandmark= '* Landmark Cannot contain any Special Characters';
      //   }
      if (!values.proposerDetails.commPincode) {
        errors.proposerDetails.commPincode = '* Required';
      }
      if (
        values.proposerDetails.commPincode &&
        (values.proposerDetails.commPincode.length !== 6 ||
          !values.proposerDetails.commPincode.match(/^[0-9]+$/))
      ) {
        errors.proposerDetails.commPincode =
          '* Pincode must be of 6 digits';
      }
      if (
        values.proposerDetails.commPincode &&
        (!values.proposerDetails.commCityTownVillage ||
          !values.proposerDetails.commState ||
          !values.proposerDetails.commDistrict)
      ) {
        errors.proposerDetails.commPincode =
          '*Click the search icon to fetch city, district and state';
      }
    }

    if (!values.proposerDetails.mobileNo) {
      errors.proposerDetails.mobileNo = '* Required';
    }
    if (
      values.proposerDetails.mobileNo &&
      (values.proposerDetails.mobileNo.length !== 10 ||
        !values.proposerDetails.mobileNo.match(/^[0-9]+$/))
    ) {
      errors.proposerDetails.mobileNo =
        '* Mobile number must be of 10 digits';
    }
    if (!values.proposerDetails.emailID) {
      errors.proposerDetails.emailID = '* Required';
    }
    if (values.proposerDetails.emailID) {
      let email_check = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!email_check.test(values.proposerDetails.emailID)) {
        errors.proposerDetails.emailID =
          '* Please enter valid email address';
      }
    }
    if (sessionStorage?.getItem('roleName')?.toString()?.toLowerCase()  === 'bancassurance' || 
    sessionStorage?.getItem('roleName')?.toString()?.toLowerCase()  === 'corporate agent') {
      if (!values.proposerDetailsMeta.ciuType ){
        errors.proposerDetailsMeta.ciuType ='* Required';
      }
      if (!values.proposerDetailsMeta.crn ){
        errors.proposerDetailsMeta.crn ='* Required';
      }
      if (values.proposerDetailsMeta.ciuType === 'Kotak Bank CRN Number'
       && !values.proposerDetailsMeta.crn  ){
        errors.proposerDetailsMeta.crn ='* Required';
      }
      if (values.proposerDetailsMeta.ciuType === 'Kotak Bank CRN Number'
       && values.proposerDetailsMeta.crn &&  !values.proposerDetailsMeta.isCRNVerified){
        errors.proposerDetailsMeta.isCRNVerified ="Verify the CRN Number before proceeding";
      }
    }
    if (values.proposerDetailsMeta.crn  && values.proposerDetailsMeta.ciuType === 'Kotak Bank CRN Number'){
      if (values.proposerDetailsMeta.crn.length < 5){
        errors.proposerDetailsMeta.crn ='*CRN Number must be greater than 5 digit';
       } 
       else if( values.proposerDetailsMeta.crn.length > 16) {
           errors.proposerDetailsMeta.crn ='*CRN Number can be maximum of 16 digit';
       }
   }
    if (Object.keys(errors.proposerDetails).length === 0
    && Object.keys(errors.proposerDetailsMeta).length === 0) {
      errors = {};
    }
    return errors;
  };

  const ProposerForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();

    const data = [
      {
        title: 'Business Type',
        grid_data: [
          {
            type: 'render',
            component: () => (
              <Text>
                <FontAwesomeIcon
                  icon={faCheck}
                  className="mr-2 text-success"
                />
                {getDomainData(
                  businessTypeList,
                  buyHealthPolicy?.quotationType,
                  'code',
                  'value',
                )}
              </Text>
            ),
          },
        ],
      },
      {
        title: 'Proposer Customer',
        grid_data: !buyHealthPolicy.isQuoteSaved
          ? [
            {
              type: 'render',
              colSpan: repeat,
              component: () => (
                <div
                  className={
                    repeat === 4
                      ? 'mb-2 flex justify-start space-x-4'
                      : 'grid grid-cols-1'
                  }
                >
                  <span>
                    <Button
                      flat={
                        isNewCustomerSelected ||
                          isNewCustomerSelected === null
                          ? true
                          : false
                      }
                      type="button"
                      className={
                        repeat === 4 ? 'w-full' : 'w-full mb-2'
                      }
                      iconPre={
                        <FontAwesomeIcon
                          icon={faUserCheck}
                          className={
                            buyHealthPolicy?.quoteNumber.length !==
                              0
                              ? 'mr-1'
                              : 'mx-1'
                          }
                        />
                      }
                      disabled={
                        buyHealthPolicy?.quoteNumber.length !== 0
                      }
                      onClick={(_) => {
                        setAlerts([]);
                        setIsNewCustomerSelected(false);
                        setIsIndividualFormSelected(null);
                        setLocalExistingCustomerValues({
                          customerType: 'Individual',
                          searchType: 'Mobile Number',
                        });
                        setExistingCustomers([]);
                        setIdleDisplay(true);
                        setOnUpdate((_) => {
                          const newFunc = async (rowData) => {
                            try {
                              let queryOutput = fetchQuery({
                                query: SEARCH_CUSTOMER_BY_NUMBER,
                                fetchPolicy: 'network-only',
                                variables: {
                                  input: {
                                    customer_type:
                                      rowData.cust_type?.code,
                                    customer_number:
                                      rowData.cust_number,
                                    },
                                  },
                              });
                              setLoadingCustomerData(true);
                              let { data } = await queryOutput;
                              setLoadingCustomerData(false);
                              updateBuyHealthPolicy(
                                reinitialiseForm(data),
                              );
                            } catch (error) {
                              setErrors({
                                ...errors,
                                existingCustomers: error.message,
                              });
                              setAlerts([
                                {
                                  header:
                                    'Customer details cannot be fetched',
                                  id: Date.now(),
                                  content: (
                                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                      <span>{error.message}</span>
                                    </div>
                                  ),
                                  type: 'error',
                                  timeout: null,
                                  disableClose: false,
                                },
                              ]);
                              setLoadingCustomerData(false);
                              window.scrollTo({
                                top: 0,
                                behavior: 'smooth',
                              });
                            }
                          };
                          return newFunc;
                        });
                        showExistingCustomerModal(true);
                      }}
                    >
                      Existing Customer
                    </Button>
                  </span>
                  <span>
                    <Button
                      flat={isNewCustomerSelected ? false : true}
                      type="button"
                      className={
                        repeat === 4 ? 'w-48' : 'w-full mb-2'
                      }
                      disabled={
                        buyHealthPolicy?.quoteNumber.length !== 0
                      }
                      iconPre={
                        <FontAwesomeIcon
                          icon={faUserPlus}
                          className={
                            buyHealthPolicy?.quoteNumber.length !==
                              0
                              ? 'mr-1'
                              : 'mx-1'
                          }
                        />
                      }
                      onClick={(_) => {
                        if (!preCustomerType) {
                          if (
                            isNewCustomerSelected === false ||
                            !isIndividualFormSelected
                          ) {
                          resetProposerDetails({
                            proposerDetails: {
                              customerType: getDomainData(
                                data_cust_type_domain_arr?.customerTypeList,
                                'Individual',
                                'value',
                                'code',
                              ),
                              idProofType: defaultIdProof?.code,
                                gender:
                                  indvCustomerDomainArr
                                    ?.genderList[0]?.code ||
                                  genderList[0]?.code,
                                title:
                                  indvCustomerDomainArr
                                    ?.salutationList[0]?.code ||
                                  salutationList[0]?.code,
                                maritalStatus:
                                  indvCustomerDomainArr
                                    ?.maritalStatusList[0]?.code ||
                                  maritalStatusList[0]?.code,
                                nationality:
                                  indvCustomerDomainArr
                                    ?.nationalityList[0]?.code ||
                                  nationalityList[0]?.code,
                                  proposerDOB:preDob
                                  ?preDob
                                  :'',
                                permPincode: prePermPincode
                                  ? prePermPincode
                                  : '',
                                permCityTownVillage:
                                  prePermCityTownVillage
                                    ? prePermCityTownVillage
                                    : '',
                                permDistrict: prePermDistrict
                                  ? prePermDistrict
                                  : '',
                                permState: prePermState
                                  ? prePermState
                                  : '',
                                  idProofNumber : defaultIdProof?.code?.toString() === '3' ?
                                          '99999' :'',
                            },
                            proposerDetailsMeta: {
                              isNewCustomer: true,
                            },
                          });
                        }
                        setIsNewCustomerSelected(true);
                        setIsIndividualFormSelected(true);
                        setFieldValue(
                          'proposerDetails.customerType',
                          getDomainData(
                            data_cust_type_domain_arr?.customerTypeList,
                            'Individual',
                            'value',
                            'code',
                          ),
                        );
                        setFieldValue(
                          'proposerDetails.idProofType',
                          !values?.proposerDetails?.idProofType
                            ? defaultIdProof?.code
                              : values?.proposerDetails
                                ?.idProofType,
                            );
                            setFieldValue(
                              'proposerDetails.idProofNumber',
                              !values?.proposerDetails?.idProofNumber 
                                ?'99999'
                                : values?.proposerDetails?.idProofNumber,
                          );
                        } else {
                          if (isNewCustomerSelected === false) {
                            resetProposerDetails({
                              proposerDetails: {
                                customerType: getDomainData(
                                  data_cust_type_domain_arr?.customerTypeList,
                                  'Individual',
                                  'value',
                                  'code',
                                ),
                                idProofType: defaultIdProof?.code,
                                gender:
                                  indvCustomerDomainArr
                                    ?.genderList[0]?.code ||
                                  genderList[0]?.code,
                                title:
                                  indvCustomerDomainArr
                                    ?.salutationList[0]?.code ||
                                  salutationList[0]?.code,
                                maritalStatus:
                                  indvCustomerDomainArr
                                    ?.maritalStatusList[0]?.code ||
                                  maritalStatusList[0]?.code,
                                nationality:
                                  indvCustomerDomainArr
                                    ?.nationalityList[0]?.code ||
                                  nationalityList[0]?.code,
                                  proposerDOB:preDob
                                  ?preDob
                                  :'',
                                permPincode: prePermPincode
                                  ? prePermPincode
                                  : '',
                                permCityTownVillage:
                                  prePermCityTownVillage
                                    ? prePermCityTownVillage
                                    : '',
                                permDistrict: prePermDistrict
                                  ? prePermDistrict
                                  : '',
                                permState: prePermState
                                  ? prePermState
                                  : '',
                                  idProofNumber: defaultIdProof?.code?.toString() === '3' 
                                    ? '99999' : '',
                              },
                              proposerDetailsMeta: {
                                isNewCustomer: true,
                              },
                            });
                          }
                          setIsNewCustomerSelected(true);
                          setIsIndividualFormSelected(
                            getDomainData(
                              data_cust_type_domain_arr?.customerTypeList,
                              preCustomerType,
                              'code',
                              'value',
                            )?.toLowerCase() === 'individual'
                              ? true
                              : false,
                          );
                          setFieldValue(
                            'proposerDetails.customerType',
                            getDomainData(
                              data_cust_type_domain_arr?.customerTypeList,
                              preCustomerType,
                              'code',
                              'value',
                            )?.toLowerCase() === 'individual'
                              ? getDomainData(
                                data_cust_type_domain_arr?.customerTypeList,
                                'Individual',
                                'value',
                                'code',
                              )
                              : getDomainData(
                                data_cust_type_domain_arr?.customerTypeList,
                                'Organisation',
                                'value',
                                'code',
                              ),
                          );
                          setFieldValue(
                            'proposerDetails.idProofType',
                            !values?.proposerDetails?.idProofType
                              ? defaultIdProof?.code
                              : values?.proposerDetails
                                ?.idProofType,
                          );
                            setFieldValue(
                              'proposerDetails.idProofNumber',
                              !values?.proposerDetails?.idProofNumber 
                                ?'99999'
                                : values?.proposerDetails?.idProofNumber,
                        );
                          if (preGender) {
                            setFieldValue(
                              'proposerDetails.title',
                              !values?.proposerDetails?.title
                                ? salutationList &&
                                  salutationList?.length > 0
                                  ? salutationList?.filter(
                                    (salutation) =>
                                      salutation?.gender?.toLowerCase() ===
                                      preGender?.toLowerCase(),
                                  )?.length === 0
                                    ? salutationList[0]?.code
                                    : salutationList?.filter(
                                      (salutation) =>
                                        salutation?.gender?.toLowerCase() ===
                                        values?.proposerDetails?.gender?.toLowerCase() ||
                                        !salutation?.gender,
                                    )[0]?.code
                                  : salutationList[0]?.code
                                : values?.proposerDetails?.title,
                            );
                          } else {
                            setFieldValue(
                              'proposerDetails.title',
                              !values?.proposerDetails?.title
                                ? salutationList[0]?.code
                                : values?.proposerDetails?.title,
                            );
                          }
                          setFieldValue(
                            'proposerDetails.maritalStatus',
                            !values?.proposerDetails?.maritalStatus
                              ? dataCustomerIndividualDropdownDetails
                                ?.maritalStatusList[0]?.code
                              : values?.proposerDetails
                                ?.maritalStatus,
                          );
                          setFieldValue(
                            'proposerDetails.nationality',
                            !values?.proposerDetails?.nationality
                              ? dataCustomerIndividualDropdownDetails
                                ?.nationalityList[0]?.code
                              : values?.proposerDetails
                                ?.nationality,
                          );
                          if (preDob) {
                            setFieldValue(
                              'proposerDetails.proposerDOB',
                              preDob,
                            );
                          }
                          if (prePermPincode) {
                            setFieldValue(
                              'proposerDetails.permPincode',
                              prePermPincode,
                            );
                          }
                          if (prePermCityTownVillage) {
                            setFieldValue(
                              'proposerDetails.permCityTownVillage',
                              prePermCityTownVillage,
                            );
                          }
                          if (prePermDistrict) {
                            setFieldValue(
                              'proposerDetails.permDistrict',
                              prePermDistrict,
                            );
                          }
                          if (prePermState) {
                            setFieldValue(
                              'proposerDetails.permState',
                              prePermState,
                            );
                          }
                        }
                      }}
                    >
                      New Customer
                    </Button>
                  </span>
                </div>
              ),
            },
            isNewCustomerSelected
              ? {
                type: 'select-tabs',
                name: 'proposerDetails.customerType',
                colSpan: repeat,
                size: 'large',
                data:
                  getDomainData(
                    data_cust_type_domain_arr?.customerTypeList,
                    preCustomerType,
                    'code',
                    'value',
                  )?.toLowerCase() === 'individual'
                    ? [
                      {
                        icon: () => (
                          <FontAwesomeIcon icon={faUserTag} />
                        ),
                        label: 'Individual',
                        value:
                          data_cust_type_domain_arr?.customerTypeList
                            ? getDomainData(
                              data_cust_type_domain_arr?.customerTypeList,
                              'Individual',
                              'value',
                              'code',
                            )
                            : '',
                        onFieldChange: () => {
                          setIsIndividualFormSelected(true);
                        },
                      },
                    ]
                    : getDomainData(
                      data_cust_type_domain_arr?.customerTypeList,
                      preCustomerType,
                      'code',
                      'value',
                    )?.toLowerCase() === 'organisation'
                      ? [
                        {
                          icon: () => (
                            <FontAwesomeIcon icon={faBuilding} />
                          ),
                          label: 'Organisation',
                          value:
                            data_cust_type_domain_arr?.customerTypeList
                              ? getDomainData(
                                data_cust_type_domain_arr?.customerTypeList,
                                'Organisation',
                                'value',
                                'code',
                              )
                              : '',
                          onFieldChange: () => {
                            setIsIndividualFormSelected(false);
                          },
                        },
                      ]
                      : [
                  {
                    icon: () => (
                      <FontAwesomeIcon icon={faUserTag} />
                    ),
                    label: 'Individual',
                    value:
                      data_cust_type_domain_arr?.customerTypeList
                        ? getDomainData(
                          data_cust_type_domain_arr?.customerTypeList,
                          'Individual',
                          'value',
                          'code',
                        )
                        : '',
                    onFieldChange: () => {
                      setIsIndividualFormSelected(true);
                    },
                  },
                  {
                    icon: () => (
                      <FontAwesomeIcon icon={faBuilding} />
                    ),
                    label: 'Organisation',
                    value:
                      data_cust_type_domain_arr?.customerTypeList
                        ? getDomainData(
                          data_cust_type_domain_arr?.customerTypeList,
                          'Organisation',
                          'value',
                          'code',
                        )
                        : '',
                    onFieldChange: () => {
                      setIsIndividualFormSelected(false);
                    },
                  },
                ],
              }
              : null,
          ].filter((d) => d !== null)
          : [],
      },
    ];

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
    };

    return (
      <>
        <QuantaForm className="space-y-4">
          <InputGridGroup {...{ data, ...other_props }} />
        </QuantaForm>
        <>
          {(isNewCustomerSelected &&
            (isIndividualFormSelected ||
              values.proposerDetails.customerType ===
              getDomainData(
                data_cust_type_domain_arr?.customerTypeList,
                'Individual',
                'value',
                'code',
              ))) ||
            (!isNewCustomerSelected &&
              buyHealthPolicy?.proposerDetails?.customerType ===
              getDomainData(
                data_cust_type_domain_arr?.customerTypeList,
                'Individual',
                'value',
                'code',
              )) ? (
            <div
              className={
                buyHealthPolicy?.isQuoteSaved
                  ? 'flex flex-col space-y-4'
                  : ''
              }
            >
              {buyHealthPolicy?.isQuoteSaved && (
                <Text severity="info" type="title" className="mt-4">
                  Proposer Customer
                </Text>
              )}
              <Paper>
                <IndividualCustomerForm
                  {...{
                    isCustomerMetaDataRequired:
                      !isNewCustomerSelected,
                    validate,
                    setIndvCustomerDomainArr,
                    buyHealthPolicy,
                    isConfigImd,
                  }}
                />
              </Paper>
            </div>
          ) : (isNewCustomerSelected &&
            (isIndividualFormSelected === false ||
              values.proposerDetails.customerType ===
              getDomainData(
                data_cust_type_domain_arr?.customerTypeList,
                'Organisation',
                'value',
                'code',
              ))) ||
            (!isNewCustomerSelected &&
              buyHealthPolicy?.proposerDetails?.customerType ===
              getDomainData(
                data_cust_type_domain_arr?.customerTypeList,
                'Organisation',
                'value',
                'code',
              )) ? (
            <div
              className={
                buyHealthPolicy?.isQuoteSaved
                  ? 'flex flex-col space-y-4'
                  : ''
              }
            >
              {buyHealthPolicy?.isQuoteSaved && (
                <Text severity="info" type="title" className="mt-4">
                  Proposer Customer
                </Text>
              )}
              <Paper>
                <OrganisationCustomerForm
                  {...{
                    isCustomerMetaDataRequired:
                      !isNewCustomerSelected,
                    validate,
                    buyHealthPolicy,
                  }}
                />
              </Paper>
            </div>
          ) : null}
        </>
      </>
    );
  };

  if (
    loading ||
    loading_cust_type_domain_arr ||
    loadingCustomerData ||
    loadingBusinessType ||
    loadingDefaultIdProof||
    loadingMobileNumberLength ||
    loadingCharacterLimitList ||
    loadingCustomerIndividualDropdownDetails
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (
    error ||
    error_cust_type_domain_arr ||
    errorBusinessType ||
    errorDefaultIdProof ||
    errorMobileNumberLength ||
    errorCharacterLimitList ||
    errorCustomerIndividualDropdownDetails
  ) {
    return (
      <Error
        error={
          error ||
          error_cust_type_domain_arr ||
          errorBusinessType ||
          errorDefaultIdProof||
          errorMobileNumberLength ||
          errorCharacterLimitList ||
          errorCustomerIndividualDropdownDetails
        }
      />
    );
  }

  const { buyHealthPolicy } = data;
  const { businessTypeList } = businessTypeData;
  const { customerTypeList: getCustomerTypeDomain } =
    data_cust_type_domain_arr;
  const { defaultIdProof } = dataDefaultIdProof;
  const { mobileNumberStartingWith } = dataMobileNumberLength;
  const { characterLimitList } = dataCharacterLimitList;
 // console.log('dataCustomerIndividualDropdownDetails',dataCustomerIndividualDropdownDetails)
  const {
    genderList,
    salutationList,
    maritalStatusList,
    nationalityList,
  } = dataCustomerIndividualDropdownDetails;

  const searchInput = {
    flow: 'cols',
    repeat: 5,
    data: [
      {
        type: 'select-tabs',
        name: 'customerType',
        colSpan: 5,
        size: 'large',
        data: [
          {
            icon: () => <FontAwesomeIcon icon={faUserTag} />,
            label: 'Individual',
            value: 'Individual',
            onFieldChange: (values, setFieldValue) => {
              if (values.customerType === 'Organisation') {
                setFieldValue('customerType', 'Individual');
                setFieldValue('searchString', '');
                setFieldValue('searchType', '');
                setFieldValue('searchType', 'Mobile Number');
                setLocalExistingCustomerValues({
                  ...localExistingCustomerValues,
                  customerType: 'Individual',
                  searchType: 'Mobile Number',
                });
                setExistingCustomers([]);
                setIdleDisplay(true);
              }
            },
          },
          {
            icon: () => <FontAwesomeIcon icon={faBuilding} />,
            label: 'Organisation',
            value: 'Organisation',
            onFieldChange: (values, setFieldValue) => {
              if (values.customerType === 'Individual') {
                setFieldValue('customerType', 'Organisation');
                setFieldValue('searchString', '');
                setFieldValue('searchType', '');
                setLocalExistingCustomerValues({
                  ...localExistingCustomerValues,
                  customerType: 'Organisation',
                  searchType: '',
                });
                setExistingCustomers([]);
                setIdleDisplay(true);
              }
            },
          },
        ],
      },
      {
        type:
          localExistingCustomerValues?.searchType
            ?.toString()
            .toLowerCase() === 'mobile number'
            ? 'number'
            : 'text',
        name: 'searchString',
        step:
          localExistingCustomerValues?.searchType
            ?.toString()
            .toLowerCase() === 'mobile number'
            ? '1'
            : null,
        min: 1000000000,
        max: 9999999999,
        size: 'full',
        onKeyDown: (evt) =>
          evt.key === 'e' &&
            localExistingCustomerValues?.searchType
              ?.toString()
              .toLowerCase() === 'mobile number'
            ? evt.preventDefault()
            : true,
        placeholder: getSearchTextPlaceholder(
          localExistingCustomerValues?.searchType,
          localExistingCustomerValues?.customerType,
        ),
        onDataChange: (val, _) => {
          setLocalExistingCustomerValues({
            ...localExistingCustomerValues,
            searchString: val,
          });
        },
        colSpan: inputColSpans.searchString,
      },
      {
        type: 'select',
        name: 'searchType',
        size: 'full',
        className: 'flex flex-row justify-center items-center py-0',
        colSpan: inputColSpans.searchType,
        value: localExistingCustomerValues.searchType,
        onDataChange: (val, _) => {
          setLocalExistingCustomerValues({
            ...localExistingCustomerValues,
            searchType: val,
          });
        },
        data:
          localExistingCustomerValues.customerType === undefined ||
            localExistingCustomerValues?.customerType.toLowerCase() ===
            'individual'
            ? [
              // { label: 'Customer Name', value: 'Customer Name' },
              { label: 'Customer ID', value: 'Customer Number' },
              { label: 'Mobile Number', value: 'Mobile Number' },
              { label: 'CKYC ID', value: 'CKYC Id' },
              { label: 'PAN Number', value: 'PAN No' },
            ]
            : [
              // {
              //   label: 'Organisation Name',
              //   value: 'Customer Name',
              // },
              { label: 'Customer ID', value: 'Customer Number' },
              { label: 'CKYC ID', value: 'CKYC Id' },
              { label: 'PAN Number', value: 'PAN No' },
            ],
      },
      {
        type: 'submit',
        colSpan: inputColSpans.button,
        iconPre: <FontAwesomeIcon icon={faSearch} />,
        children: 'Search',
        size: 'full',
      },
    ],
    initialValues: {
      customerType: 'Individual',
      searchString: '',
      searchType: 'Mobile Number',
    },
    validate: (values) => {
      const errors = {};
      if (!values.customerType || values.customerType === '') {
        errors.customerType = '* Required';
      } else if (!values.searchString || values.searchString === '') {
        errors.searchString = '* Required';
      } else if (
        values.customerType === 'Individual' &&
        typeof values.searchString === 'string' &&
        ((values.searchString.toLowerCase().startsWith('mrs') &&
          values.searchString.length < 6) ||
          (values.searchString.toLowerCase().startsWith('mr') &&
            values.searchString.length < 5) ||
          (values.searchString.toLowerCase().startsWith('dr') &&
            values.searchString.length < 5) ||
          (values.searchString.toLowerCase().startsWith('miss') &&
            values.searchString.length < 7))
      ) {
        errors.searchString =
          '* Customer cannot be searched only by title';
      } else if (
        values.customerType === 'Individual' &&
        values.searchString.length < 4 &&
        values.searchType.toLowerCase() !== 'mobile number'
      ) {
        errors.searchString =
          '* Minimum 4 characters are required for individual customer search';
      } else if (
        values.customerType === 'Organisation' &&
        values.searchString.length < 3
      ) {
        errors.searchString =
          '* Minimum 3 characters are required for organisation/corporate customer search';
      } else if (
        values.customerType === 'Individual' &&
        values.searchType.toLowerCase().endsWith('name') &&
        values.searchString.match(/\d/)
      ) {
        errors.searchString =
          '* Customer name cannot be alphanumeric';
      } else if (
        values.searchType.toLowerCase() === 'mobile number' &&
        (values.searchString.toString().length !== 10 ||
          !values.searchString.toString().match(/^[0-9]+$/))
      ) {
        errors.searchString = '* Mobile number must be of 10 digits';
      } else if (!values.searchType || values.searchType === '') {
        errors.searchType = '* Required';
      }
      return errors;
    },
    onSearch: async (values) => {
      const { searchType, customerType, searchString } = values;
      setIdleDisplay(false);
      try {
        setExistingCustomers([]);
        let queryOutput = fetchQuery({
          query: SEARCH_CUSTOMERS,
          variables: {
            filter: {
            ...getSearchObject(
              getDomainData(
                getCustomerTypeDomain,
                customerType,
                'value',
                'code',
              ),
              searchType,
              searchString,
            ),
          },
          },
        });
        setLoadingExistingCustomers(true);
        let { data } = await queryOutput;
        setLoadingExistingCustomers(false);
        setExistingCustomers(data.customers);
        setCustomerSearchMetaMessage({
          type: data._customer_meta.metaMessage.type,
          message: data._customer_meta.metaMessage.message,
        });
      } catch (error) {
        setErrors({
          ...errors,
          existingCustomers: error.message,
        });
        setLoadingExistingCustomers(false);
        setExistingCustomers([]);
      }
    },
  };

  const searchResults = {
    data: existingCustomers,
    onIdle: () => {
      if (loadingExistingCustomers) {
        return <Loading />;
      } else if (isIdleDisplay) {
        return icon_idle;
      }
      return undefined;
    },
    dependencies: [
      localExistingCustomerValues?.customerType,
      localExistingCustomerValues?.searchString,
    ],
    columns: [
      {
        Header: 'Customer ID',
        accessor: 'cust_number',
      },
      {
        Header:
          !localExistingCustomerValues.customerType ||
            localExistingCustomerValues?.customerType === 'Individual'
            ? 'Customer Name'
            : 'Organisation Name',
        Cell: ({ row }) => (
          <span>
            {row.original.cust_type.value === 'Individual'
              ? row.original.indv_detail.full_name
              : row.original.org_detail.org_name}
          </span>
        ),
      },
      {
        Header: 'Location',
        Cell: ({ row }) => {
          return (
            <div className="text-base">
              {row.original.permanent_address.location}
            </div>
          );
        },
      },
      localExistingCustomerValues.customerType === 'Individual'
        ? {
          Header: 'Contact',
          Cell: ({ row }) => {
            return (
              <span>
                <div className="flex flex-col -mb-1 -mt-1 item-baseline justify-center">
                  <div className="text-base">
                    {row.original.contact.mobile}
                  </div>
                  <div className="text-base">
                    {row.original.contact.email}
                  </div>
                </div>
              </span>
            );
          },
        }
        : {},
    ].filter((d) => d.Header !== undefined),
    list: existingCustomers.map((data) => {
      return {
        title: `${data.cust_type.value === 'Individual'
          ? data.indv_detail.full_name
          : data.org_detail.org_name
          } (${data.cust_number})`,
        subtitle: `${data.permanent_address.location}`,
        onClick: () => {
          showExistingCustomerModal(false);
          onDataUpdate(data);
          document.body.classList.remove('overflow-y-hidden');

        },
      };
    }),
    sortBy: { id: 'customer_number', desc: false },
  };

  const paginationInput = {
    offset: 0,
    PAGE_SIZE: 4,
  };

  const onMessage = () => {
    return (
      customerSearchMetaMessage &&
      customerSearchMetaMessage.type &&
      customerSearchMetaMessage.message && (
        <Text
          severity={customerSearchMetaMessage.type}
          className="space-x-1"
        >
          <div className="flex flex-row">
            <div>
              <FontAwesomeIcon
                icon={
                  customerSearchMetaMessage.type === 'info'
                    ? faExclamationCircle
                    : customerSearchMetaMessage.type === 'warning'
                      ? faExclamationTriangle
                      : faTimesCircle
                }
                className={`mr-1 text-${customerSearchMetaMessage.type}`}
              />
            </div>
            <div>{customerSearchMetaMessage.message}</div>
          </div>
        </Text>
      )
    );
  };

  const onClose = () => {
    showExistingCustomerModal(false);
  };

  const onNoResultsFound = () => {
    return errors.existingCustomers;
  };

  const saveQuoteVariables = (
    lob_code,
    product_code,
    custData,
    quotationType,
    members,
    cover,
    healthPlans,
    location,
    existingPolicyNumber,
    deductSumInsured,
  ) => {
    return {
      input: {
        quotationType: quotationType,
        quoteCreationDate: moment().format('YYYY-MM-DD').toString(),
        customer: custData,
        // custCkyc: '123444',
        // panNo: 'BSAPG7676S',
        lob: lob_code,
        product: product_code,
        location: {
          pinCode: location?.pincode,
          state: location?.state,
          district: location?.district,
          city: location?.city,
          zone: location?.zone,
        },
        intermediary: {
          intermediaryCode: prembuyHealthPolicy?.intermediaryDetails.code,
          locationCode: prembuyHealthPolicy?.intermediaryDetails?.location,
          fieldUserCode: prembuyHealthPolicy?.intermediaryDetails?.fieldUserCode,
        },
        members: members
          .filter((mem) => mem?.selected)
          .map((member) => {
            return {
              relationship: member?.relationship,
              gender: member?.gender,
              dob: member?.dob,
              age: member?.age?.toString(),
            };
          }),
        cover: {
          type: cover?.type,
          sumInsured: parseInt(cover?.sum_insured),
          tenure: cover?.tenure,
          deductibleSumInsured: parseInt( deductSumInsured),
        },
        plans: healthPlans?.plans
          ?.filter((plan) => plan?.isSelected)
          ?.map((plan) => {
            return {
              name: plan?.name,
              code: plan?.code,
              covers: plan?.covers?.map((cover) => {
                return { name: cover?.name, index: cover?.index };
              }),
              packs: plan?.packs?.map((pack) => {
                return {
                  name: pack?.name,
                  index: pack?.index,
                  addOnCovers: pack?.addOnCovers?.map((addOn) => {
                    return {
                      name: addOn?.name,
                      index: addOn?.index,
                      selected: addOn?.selected,
                    };
                  }),
                };
              }),
              premium: {
                basePremium: plan?.premium?.basePremium,
                loadingDiscount: plan?.premium?.loadingDiscount,
                netPremium: plan?.premium?.netPremium,
                gst: plan?.premium?.gst,
                stampDuty: plan?.premium?.stampDuty,
                totalPremium: plan?.premium?.totalPremium,
                loading: plan?.premium?.loading?.map((loading) => {
                  return {
                    name: loading?.name,
                    amount: loading?.amount,
                  };
                }),
                discount: plan?.premium?.discount?.map((discount) => {
                  return {
                    name: discount?.name,
                    amount: discount?.amount,
                  };
                }),
                breakup: plan?.premium?.breakup?.map((brkup) => {
                  return {
                    relationship: brkup?.relationship,
                    gender: brkup?.gender,
                    age: brkup?.age,
                    premium: brkup?.premium,
                  };
                }),
              },
            };
          }),
        existingPolicyNumber,
        isExistingEmployee: custData?.employeeNumber ? true : false,
      },
    };
  };

  const submitProposerForm = async (values) => {
    if (Object.keys(validate(values)).length === 0) {
      if(!values?.proposerDetails?.id &&
        (isIndividualFormSelected === true ||
          getDomainData(
            data_cust_type_domain_arr?.customerTypeList,
            values?.proposerDetails?.customerType,
            'code',
            'value',
          )?.toLowerCase() === 'individual') ){
        let doCheckDuplicateCust = fetchQuery({
          query: CHECK_DUPLICATE_CUSTOMER,
          fetchPolicy: 'network-only',
          variables : {
            inputCust:checkDuplicateCustVariables(values?.proposerDetails),
           },
      });

      const { data: checkDuplicateCust } = await doCheckDuplicateCust;
     
      if(checkDuplicateCust?.checkDuplicateCust?.ErrorMsg  === "")  {
      
        setIsDuplicateCustomer(1)
        setParentAlerts([]);
      }else{
        setIsDuplicateCustomer('')
        setAlerts([
          {
            ...alerts,
            header: 'Customer details ',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{checkDuplicateCust?.checkDuplicateCust?.ErrorMsg}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ])
        setProceedToNextStep([
          false,
          ...proceedToNextStep.slice(1),
        ])
        return false;
      }
      }
      if (!buyHealthPolicy.quoteNumber) {
        try {
          const { renewalMandateDetails, ...restProposerDetails } =
            values?.proposerDetails;
          let doSaveQuote = mutateQuery({
            mutation: SAVE_QUOTE,
            variables: saveQuoteVariables(
              lob_code,
              product_code,
              restProposerDetails,
              values.quotationType,
              values?.quoteData?.members,
              values?.quoteData?.cover,
              values?.planData,
              values?.quoteData?.location,
              values?.quoteData?.existingPolicyNumber,
              values?.quoteData?.deductSumInsured,
            ),
          });
          setParentAlerts([]);
          setCustomLoadingMessage('Saving Quote');
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setLoadingStep(true);
          let { data } = await doSaveQuote;
          setLoadingStep(false);
          setParentAlerts([
            {
              header: 'Quote Save Success',
              id: Date.now(),
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Quote Saved successfully for{' '}
                    <span className="font-bold">
                      {values?.proposerDetails?.customerType ===
                        getDomainData(
                          data_cust_type_domain_arr?.customerTypeList,
                          'Individual',
                          'value',
                          'code',
                        )
                        ? [
                          values?.proposerDetails?.title?.trim(),
                          values?.proposerDetails?.firstName?.trim(),
                          values?.proposerDetails?.middleName?.trim(),
                          values?.proposerDetails?.lastName.trim(),
                        ]
                          .filter((n) => n)
                          .join(' ')
                        : values?.proposerDetails?.orgName}
                    </span>
                  </Text>
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Quotation Number: {data.saveQuote.quoteNumber}
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
          ]);
          updateBuyHealthPolicy({
            ...values,
            quoteNumber: data.saveQuote.quoteNumber,
            quoteStatus: data.saveQuote.status,
          });
          return true;
        } catch (error) {
          setLoadingStep(false);
          setParentAlerts([
            {
              header: 'Error',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  {error.message}
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setProceedToNextStep([
            false,
            ...proceedToNextStep.slice(1),
          ]);
          return false;
        }
      }  else if(buyHealthPolicy.quoteNumber || isDuplicateCustomer !== ''  ){
        setParentAlerts([]);
        setProceedToNextStep([true, ...proceedToNextStep.slice(1)]);
        updateBuyHealthPolicy(values);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return true;
      }
    } else {
      setProceedToNextStep([false, ...proceedToNextStep.slice(1)]);
      updateBuyHealthPolicy(values);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    }
  };

  return (
    <div>
      <div>
        <SearchResultsModal
          {...{
            modalDisplay: existingCustomerModal,
            searchInput,
            searchResults,
            paginationInput,
            title: 'Search Existing Customer',
            onClose,
            onDataUpdate,
            onNoResultsFound,
            onMessage,
            selectOnRowClick: true,
            firstRowClickRequired: false,
            className:
              'h-screen flex flex-col justify-start w-screen',
          }}
        />
      </div>
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
      <QuantaFormik
        {...{
          innerRef: props.forwardedRef,
          initialValues: buyHealthPolicy,
          validate,
          onSubmit: submitProposerForm,
          enableReinitialize: true,
          validator: () => ({}),
        }}
      >
        <ProposerForm {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
